export type IconProps = {
    height?: string;
    width?: string;
    className?: string;
    onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
};
